import { Pagination } from 'src/io/models/http/pagination'
import { CollectionRequestParams } from 'src/io/models/http/collection-request-params'

const DEFAULT_COLLECTION_NODES_LIMIT = 15
const defaultPagination: Pagination = {
  page: 1,
  pages: 1,
  limit: DEFAULT_COLLECTION_NODES_LIMIT,
  sort: 'recent'
}

export const defaultCollectionRequestParams: CollectionRequestParams = {
  ...defaultPagination,
  view: 'Completed',
  live_only: undefined,
  event_status: undefined,
  type: undefined,
  collectionId: undefined,
  collectionTag: undefined,
  nodeId: undefined,
  version: undefined
}
